import React from 'react'
import styles from './levelmanagement.module.css'

function Leveltabletitle() {
    return (
      <>
<div className = {styles.leaveText}>
          <h4 className ={styles.tableTitle}>Level Management</h4>
          {/* <i id="altPopup" class="fa-solid fa-circle-plus" onclick="openPopup()"></i> */}
        </div>

      </>
    )
}

export default Leveltabletitle